import { useEffect } from "react";
import { useWebSocket } from "./useWebSocket";
import { useBikeStore } from "../store/useBikeStore";

export function useRealtime() {
  const { connected, on, off } = useWebSocket({
    autoConnect: true,
  });

  const upsertBikeFromRealtime = useBikeStore(
    (state) => state.upsertBikeFromRealtime,
  );

  useEffect(() => {
    if (!connected) return;

    const handleBikeUpdate = (data: {
      bike_id: string;
      latitude: number;
      longitude: number;
      status: string;
      is_moving: boolean;
      timestamp: string;
      speed?: number;
      battery_level?: number;
    }) => {
      upsertBikeFromRealtime(data);
    };

    on("bikeUpdate", handleBikeUpdate);

    return () => {
      off("bikeUpdate", handleBikeUpdate);
    };
  }, [connected, upsertBikeFromRealtime, on, off]);

  return { connected };
}
